var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "商 品",
        visible: _vm.centerDialogVisible,
        width: "47%",
        center: "",
      },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { padding: "20px" },
        },
        [
          _vm.centerDialogVisible
            ? _c(
                "div",
                _vm._l(_vm.dataArr, function (items) {
                  return _c(
                    "div",
                    {
                      key: items.inquiryQuotationId,
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      items.inquiryQuotationStatusMap
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                "margin-bottom": "5px",
                                display: "flex",
                                "align-items": "center",
                                color: "#CA582E",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-star-on",
                                staticStyle: { "font-size": "24px" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    items.inquiryQuotationStatusMap.value
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "100px",
                            "border-radius": "15px 15px 0 0",
                            border: "2px solid #CB582E",
                            padding: "10px",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("img", {
                                  staticStyle: {
                                    width: "80px",
                                    height: "80px",
                                    "margin-right": "20px",
                                  },
                                  attrs: {
                                    src: "https://img0.baidu.com/it/u=3918752675,1798038530&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1731430800&t=cef30ea146989335b8496e7c2ec2b295",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "22px" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-size": "16px",
                                          "font-weight": "bold",
                                          color: "#000",
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(items.resourceNameCn) + " "
                                            ),
                                            items.resourceNameEn
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(items.resourceNameEn)
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticStyle: { color: "#A5ADB7" } },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-location",
                                        }),
                                        _vm._v(" " + _vm._s(items.address)),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100px",
                                    "background-color": "#F2F4F4",
                                    position: "absolute",
                                    right: "0",
                                    top: "0",
                                    display: "flex",
                                    "align-items": "center",
                                    "flex-direction": "column",
                                    "justify-content": "space-between",
                                    "border-radius": "0 9px 0 0",
                                    overflow: "hidden",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        height: "30px",
                                        "background-color": "#CB582E",
                                        width: "100%",
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "center",
                                        color: "#fff",
                                      },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "16px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              items.totalPrice.toFixed(0)
                                            ) + " "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("¥")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            padding: "10px",
                            border: "2px solid #CB582E",
                            "border-top": "none",
                            "line-height": "24px",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("div", { staticStyle: { flex: "1" } }, [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  "font-weight": "bold",
                                  color: "#000",
                                },
                              },
                              [_vm._v(_vm._s(items.productNameCn) + " ")]
                            ),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  color: "rgb(21, 89, 105)",
                                  "font-weight": "bold",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(items.cancelPolicyAndOption) + " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "13px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "font-size": "13px",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          color: "#000",
                                        },
                                      },
                                      [_vm._v(_vm._s(items.dateRange))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#CA582E",
                                      "margin-right": "3px",
                                    },
                                  },
                                  [_vm._v("报价")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#000",
                                      "font-size": "14px",
                                      "font-weight": "bold",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [_vm._v(_vm._s(items.offerStr))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#000",
                                      "font-size": "14px",
                                      "font-weight": "bold",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [
                                    _vm._v("共 "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#CA582E",
                                          "font-size": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(items.totalPrice.toFixed(0)) +
                                            "￥"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _c("el-checkbox", {
                            attrs: {
                              size: "medium",
                              checked: _vm.selectArr.includes(items.stockId),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectChange(items.stockId)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.pay } },
            [_vm._v("创建订单")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }